import { useEffect, useState } from 'react'
import Spinner from '../Spinner/Spinner'
import Page from './Page'
import Alert from '../Alert/Alert'

const Contacts = () => {
	const [contacts, setcontacts] = useState([])
	const [loading, setLoading] = useState(false)

	const token = JSON.parse(localStorage.getItem('user'))

	useEffect(() => {
		setLoading(true)
		fetch('https://cp-node-api.herokuapp.com/api/contact')
			.then((res) => res.json())
			.then((data) => [setcontacts(data), setLoading(false)])
	}, [])

	const handleDelete = (id) => {
		fetch(`https://cp-node-api.herokuapp.com/api/contact/${id}`, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				token: `Bearer ${token.accessToken}`,
			},
		})
			.then((res) => res.json())
			.then((data) => {
				let newContacts = contacts.filter((c) => c._id !== data._id)
				setcontacts(newContacts)
			})
	}

	return (
		<Page>
			{loading ? (
				<Spinner />
			) : (
				<>
					{contacts.length > 0 ? (
						<table className='table table-striped table-hover table-responsive w-50'>
							<thead>
								<tr>
									<th scope='col'>#</th>
									<th scope='col'>Name</th>
									<th scope='col'>Email</th>
									<th scope='col'>Company</th>
									<th scope='col'>Phone</th>
									<th scope='col'>Created At</th>
								</tr>
							</thead>
							<tbody>
								{contacts.map((contact, i) => (
									<tr key={contact._id}>
										<th scope='row'>{i + 1}</th>
										<td>{contact.name}</td>
										<td>
											<a href={`mailto:${contact.email}`}>
												{contact.email}
											</a>
										</td>
										<td>{contact.company}</td>
										<td>{contact.phone}</td>
										<td>{contact.createdAt}</td>
										<td>
											<button
												onClick={() =>
													handleDelete(contact._id)
												}
												className='btn btn-danger'
											>
												Delete
											</button>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					) : (
						<div className='w-50'>
							<Alert msg='No Contact Info found' />
						</div>
					)}
				</>
			)}
		</Page>
	)
}

export default Contacts
